import { emptyString } from '@atlassian/amkt-common';
import { RequestStatus } from '@atlassian/mpac-api-client';
import { log } from '@atlassian/mpac-utils';
import { changeAppRequestStatus } from '../../services/AppRequests';
import { getCloudIdFromHostInfo } from '../../services/HostInfoApi';
import getSPI from '../../services/SPI';
import { doRetrieveFreshInstalledApps } from '../InstalledApps';
export const updateInstalledAppsPostInstall = (dispatch, context, hostConfig) => {
  dispatch(doRetrieveFreshInstalledApps({
    context,
    hostConfig,
    search: emptyString,
    flags: {}
  }));
};
export async function updateAllRequestStatusesPostInstall(_ref) {
  let {
    hostInfo,
    appKey,
    appName
  } = _ref;
  try {
    const productName = hostInfo.product;
    const cloudId = getCloudIdFromHostInfo(hostInfo);
    const currentUserId = await getSPI().getCurrentUser().then(currentUser => currentUser.atlassianAccountId);
    if (cloudId) {
      try {
        changeAppRequestStatus({
          productName,
          cloudId,
          appKey,
          appName,
          userId: currentUserId,
          status: RequestStatus.INSTALLED
        });
      } catch (error) {
        log.error('postInstallActions/updateAllRequestStatusesPostInstall', "Failed to update the app request status to installed", {
          error
        });
      }
    } else {
      log.error('postInstallActions/updateAllRequestStatusesPostInstall', 'Could not fetch cloudId from hostInfo');
    }
  } catch (error) {
    log.error('postInstallActions/updateAllRequestStatusesPostInstall', 'failed to get Current User', {
      error
    });
  }
}